import React, {useEffect} from 'react';
import {FormControl, InputLabel} from "@mui/material";
import {SelectSmart} from "../CustomTextField";
import Strings from "../../assets/strings";
import {useAppDispatch, useAppSelector} from "../../redux/hooks";
import {mostrarZonasHorarias} from "../../redux/reducers/zonasHorariasReducers";


interface Iprops{
    value:string,
    label?:string,
    name?: string,
    onChange?:(e: React.ChangeEvent<HTMLInputElement>)=>void,
    required?: boolean
}


export default function SelectZonaHoraria({ value = "", label="",name="zonaHorariaId", onChange, required}:Iprops) {

    const dispatch = useAppDispatch();
    const zonasHorarias = useAppSelector(state => state.zonasHorarias);

    useEffect(() => {
        dispatch(mostrarZonasHorarias())
    }, [dispatch]);

    let options = (zonasHorarias.list?.map(opc=>({key:opc.key!.toString(),value:opc.value}))) || [];
    options.unshift({key:"",value:Strings.seleccione});



    if(!onChange){
        let opcion = options.find(o=>o.key.toString() === value.toString())
        if(opcion) return  <>{opcion.value}</>;
        return <>-</>
    }

    return (

        <FormControl fullWidth required={required}>
            <InputLabel shrink>{label}</InputLabel>
            <SelectSmart
                value={value}
                onChange={onChange}
                name={name}
                loading={zonasHorarias.status === "loading"}
                opciones={options}
            />
        </FormControl>

    );
}

